import { Collection } from '../../../../types/CollectionTypes'
import { NFTCollectionBaseCard } from './NFTCollectionBaseCard'
import { NFTCollectionFooterCard } from './NFTCollectionFooterCard'

interface NFTCollectionCardProps {
  collection: Collection
  className?: string
}

export function NFTCollectionCard({ collection, className }: NFTCollectionCardProps) {
  return (
    <NFTCollectionBaseCard
      banner_url={collection.banner_url}
      className={className}
      Link={`/rockpool/${collection.chainId}/collections/${collection.slug}`}
    >
      <NFTCollectionFooterCard collection={collection} />
    </NFTCollectionBaseCard>
  )
}
